import {LicenseType as LicenseTypes} from 'src/openapi/admin/models/LicenseType';

import type {LicenseUpdateRequest} from 'src/openapi/admin/models/LicenseUpdateRequest';

export const DEFAULT_CREATE_LICENSE_DATA: LicenseUpdateRequest = {
    licenseType: LicenseTypes.UN,
    startDate: '',
    endDate: '',
};
